import { useFormState } from 'react-final-form';
import { Step2 } from './Step2';
import { Step3to5 } from './Step3to5';
import { Step6 } from './Step6';
import { ShowLoading } from 'src/shared/components/ShowLoading';
import { ShowError } from 'src/shared/components/ShowError';
import { Step } from '../../components/Step';
import { useTranslation } from 'react-i18next';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import { useGetPersonioParamsQuery } from 'src/shared/api/integrations/personio';

type AfterConnectionProps = {
  isConnected?: boolean;
};

export const AfterConnection = ({ isConnected }: AfterConnectionProps) => {
  const { t } = useTranslation('settings');
  const {
    values: { subsidiary }
  } = useFormState();
  const { data, isLoading, isError, error } = useGetPersonioParamsQuery({ subsidiary }, { skip: !isConnected });

  if (isError) {
    const errorStatus = 'status' in error ? error?.status : error;

    if (errorStatus === 403) {
      return (
        <ShowError
          error={undefined}
          additionalText={t('integrations.personio.error.the entered credentials have expired', {
            statusCode: errorStatus
          })}
        />
      );
    }

    return <ShowError error={error} />;
  }

  if (isLoading || !data) {
    return <ShowLoading />;
  }

  return (
    <>
      <Step2 data={data.subcompanies} />
      <Step3to5 departments={data.departments} offices={data.offices} leaveTypes={data.leaveTypes} />
      <Step6 customFields={data.customFields} />
      <Step
        title={`${t('integrations.step')} 7`}
        subtitle={t('integrations.factorial.review the data in the view edit employees section')}
        Icon={HowToRegIcon}
      />
    </>
  );
};
